import router from '@/router'
import { DateTime } from 'luxon'
import lookups from '@/assets/json/clientLookups.json'
import client_config from '@/assets/json/client_config.json'
import useFormatDate from '@/composables/useFormatDate'
import { useFormStore } from '@/stores/form'
import { useGlobalStore } from '@/stores/global'

export default function () {
  const formStore = useFormStore()
  const serviceTransactionId = router.currentRoute.value.params.serviceId

  let birthday =
    formStore?.extraMap?.dateOfBirth && DateTime.fromISO(formStore?.extraMap?.dateOfBirth)
  birthday =
    birthday &&
    DateTime.now().diff(birthday, 'years').years &&
    Math.floor(DateTime.now().diff(birthday, 'years').years)

  const {
    educationLevelId,
    workTypeId,
    preferedLanguageId,
    changePersonPhotoFlag,
    deliveryCompanyId,
    deliveryMethodId,
    mobileNumbers,
    havePoBox
  } = formStore.form.values
  const {
    disableDeliveryInfoSection,
    showChangePersonPhoto,
    showCurrentMobileNumber,
    showMobileNumbersListForTawzee,
    enableNewSharedUserAddreses,
    enableNewDeliverySection,
    enableZajelDelivery,
    showBoxNumberMsg,
    showAmerDeliveryAddress,
    haveExemptions,
    disableAmerDeliveryCity,
    isInCompleteDraftFlag,
    disableAmerDeliveryEmirate,
    disableZajelDeliveryArea,
    disableZajelDeliveryCity,
    disableTawzeaDeliveryArea,
    disableTawzeaDeliveryCity
  } = formStore.extraMap
  return {
    dateOfBirth: birthday,
    serviceTransactionId,
    urgentServiceFlag: false,
    enableReplacement: [561, 571].includes(+serviceTransactionId),
    educationLevelId,
    workTypeId,
    disableDeliveryInfoSection,
    preferedLanguageId,
    showChangePersonPhoto,
    changePersonPhotoFlag,
    showCurrentMobileNumber,
    deliveryCompanyId,
    deliveryMethodId,
    showMobileNumbersListForTawzee,
    enableNewSharedUserAddreses,
    enableNewDeliverySection,
    enableZajelDelivery,
    showBoxNumberMsg,
    showAmerDeliveryAddress,
    mobileNumbers,

    haveExemptions,
    disableAmerDeliveryCity,
    isInCompleteDraftFlag,
    disableAmerDeliveryEmirate,
    disableZajelDeliveryArea,
    disableZajelDeliveryCity,
    disableTawzeaDeliveryArea,
    disableTawzeaDeliveryCity,
    havePoBox
  }
}
